import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import QRCode from 'qrcode';

// Profil menüsündeki "Uygulama Kur" öğesi + QR popup'ı.
// Telefon QR'ı okutunca backend'in gömülü APK'sını indirir:
//   QR / link     ->  <origin>/api/app/download   (web YARP ile backend'e proxy'ler)
//   APK var mı?   ->  GET /api/app/manifest       (404 = bu imaja APK gömülü değil)
//   SÜRÜM         ->  GET /salesops-settings.json (dağıtılan imajın sürümü)
//
// Sürüm neden manifest'ten OKUNMUYOR: manifest'in versionName'i APK'nın kendi
// AGP metadata'sından yazılır (pipelines/templates/stage-apk.yml); gradle CI'ın
// -PversionName'ini okumadığında APK'da modül varsayılanı kalır ve popup yanlış
// sürüm gösterirdi. Dağıtım sürümü ise imaja build-arg ile işlenir (Dockerfile ->
// wwwroot/salesops-settings.json) ve ortamın gerçek sürümüdür. Dosya yoksa
// (lokal dev server) manifest'teki değere düşeriz.

const ov = {
  position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)',
  display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
};
const cardStyle = {
  background: 'var(--bg-card, #fff)', border: '1px solid var(--border-color, rgba(15,23,42,0.1))',
  borderRadius: 12, padding: 24, width: 360, maxWidth: '90vw', textAlign: 'center',
  boxShadow: '0 24px 70px rgba(15,23,42,0.32)',
};
const btn = {
  border: '1px solid var(--border-color, rgba(15,23,42,0.18))', background: 'var(--bg-card,#fff)',
  color: 'var(--text-primary,#111827)', borderRadius: 8, padding: '7px 14px', cursor: 'pointer',
  fontSize: 13, fontWeight: 600, textDecoration: 'none',
};

// APK indirme URL'i MUTLAK olmalı (telefon tarayıcısı açacak). Ayrı bir apiBaseUrl
// tanımlıysa onu, yoksa web origin'ini kullan (web /api/**'i backend'e proxy'ler).
function apiOrigin() {
  const cfg = (typeof window !== 'undefined' && window.__DATASCOPE_CONFIG__ && window.__DATASCOPE_CONFIG__.apiBaseUrl) || '';
  if (cfg) return cfg.replace(/\/+$/, '');
  return window.location.origin;
}

export function AppInstallItem() {
  const [open, setOpen] = useState(false);
  const [dataUrl, setDataUrl] = useState('');
  const [info, setInfo] = useState(null);
  const [version, setVersion] = useState('');
  const [error, setError] = useState(false);

  const downloadUrl = `${apiOrigin()}/api/app/download`;

  useEffect(() => {
    if (!open) return undefined;
    let alive = true;
    setError(false);

    QRCode.toDataURL(downloadUrl, { width: 320, margin: 1, errorCorrectionLevel: 'M' })
      .then((u) => { if (alive) setDataUrl(u); })
      .catch(() => { if (alive) setDataUrl(''); });

    // apiBase.js /api/** fetch'lerini doğru host'a yönlendirir.
    fetch('/api/app/manifest')
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((j) => { if (alive) { setInfo(j); setError(false); } })
      .catch(() => { if (alive) { setInfo(null); setError(true); } });

    // Dağıtım sürümü — web imajının wwwroot'undan servis edilen statik dosya.
    // no-store: sürüm dosyası imajla birlikte değişir, bayat cevap gösterilmemeli.
    fetch('/salesops-settings.json', { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((j) => { if (alive) setVersion(j && j.version ? String(j.version) : ''); })
      .catch(() => { if (alive) setVersion(''); });

    return () => { alive = false; };
  }, [open, downloadUrl]);

  const fmtSize = (b) => (b ? `${(b / 1048576).toFixed(1)} MB` : '');

  // Dağıtım sürümü esas; yoksa (dosya yok ya da build-arg geçilmemiş -> "0.0.0")
  // manifest'in versionName'ine düş.
  const shownVersion = (version && version !== '0.0.0' ? version : '') || (info && info.versionName) || '';

  return (
    <>
      <button type="button" className="topbar-account-install" onClick={() => setOpen(true)}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="7" y="2" width="10" height="20" rx="2" />
          <path d="M12 18h.01" />
          <path d="M12 7v5" />
          <path d="M9.5 10.5 12 13l2.5-2.5" />
        </svg>
        <span>Uygulama Kur</span>
      </button>

      {/* data-app-install-modal: modal createPortal ile document.body'ye basilir,
          yani profil menusunun DISINDA yasar. TopbarActions'in "disari tiklandi"
          dinleyicisi (document mousedown) bu tiklamalari menu disi sayip menuyu
          kapatiyordu; menu kapaninca AppInstallItem unmount oluyor ve modal da
          yok oluyordu (sol tikta link tiklama tamamlanmadan siliniyordu -> indirme
          hic baslamiyordu). O dinleyici bu isaretleyiciyi gorup modali muaf tutar. */}
      {open && createPortal(
        <div style={ov} data-app-install-modal="" onClick={() => setOpen(false)}>
          <div style={cardStyle} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 4px', fontSize: 16, color: 'var(--card-text-strong,#0b2046)' }}>Uygulama Kur</h3>
            <div style={{ fontSize: 12, color: 'var(--text-secondary,#6b7280)', marginBottom: 14 }}>
              Telefonunuzla QR kodu okutup Android uygulamasını indirin.
            </div>

            {dataUrl
              ? <img src={dataUrl} alt="Uygulama indirme QR" style={{ width: 240, height: 240 }} />
              : <div style={{ padding: 40, color: 'var(--text-secondary,#6b7280)' }}>Üretiliyor…</div>}

            {info && (
              <div style={{ marginTop: 12, fontSize: 12, color: 'var(--text-secondary,#6b7280)' }}>
                {shownVersion ? <>Sürüm <strong>{shownVersion}</strong></> : null}
                {shownVersion && info.sizeBytes ? ' · ' : ''}
                {info.sizeBytes ? fmtSize(info.sizeBytes) : ''}
              </div>
            )}
            {error && (
              <div style={{ marginTop: 12, fontSize: 12, color: 'var(--text-secondary,#6b7280)' }}>
                Bu ortamda yüklü bir uygulama sürümü bulunamadı.
              </div>
            )}

            <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 16 }}>
              {/* download: tarayici SAYFA GEZINMESI yerine indirme baslatsin. Ayni
                  origin'de gecerlidir (apiBaseUrl bos -> web origin); farkli origin'de
                  tarayici yok sayar, o durumda sunucunun Content-Disposition'i devreye
                  girer. target/rel: indirme SPA'yi terk etmesin, modal acik kalsin.
                  APK yoksa (manifest 404) link TIKLANAMAZ - aksi halde kullanici
                  JSON hata sayfasina dusuyordu. */}
              <a
                href={downloadUrl}
                download="salesops.apk"
                target="_blank"
                rel="noopener noreferrer"
                aria-disabled={error || undefined}
                tabIndex={error ? -1 : undefined}
                style={error ? { ...btn, opacity: 0.5, pointerEvents: 'none' } : btn}
              >
                Doğrudan indir
              </a>
              <button type="button" style={btn} onClick={() => setOpen(false)}>Kapat</button>
            </div>
          </div>
        </div>,
        document.body,
      )}
    </>
  );
}

export default AppInstallItem;
